/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_ResourcesInputs */

const zh_sidebar_resources = /** @type {(inputs: Sidebar_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的文件`)
};

const en_sidebar_resources = /** @type {(inputs: Sidebar_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Files`)
};

const es_sidebar_resources = /** @type {(inputs: Sidebar_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis Archivos`)
};

/**
* | output |
* | --- |
* | "My Files" |
*
* @param {Sidebar_ResourcesInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const sidebar_resources = /** @type {((inputs?: Sidebar_ResourcesInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_ResourcesInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_sidebar_resources(inputs)
	if (locale === "en") return en_sidebar_resources(inputs)
	return es_sidebar_resources(inputs)
});